import React from "react";
import { FaStar } from "react-icons/fa";
import video1_poster from "../assets/images/video1_poster.png";
import video2_poster from "../assets/images/video2_poster.png";

function StarRating({ count = 5 }) {
  return (
    <div className="flex gap-1 text-yellow-400">
      {Array.from({ length: count }).map((_, i) => (
        <FaStar key={i} />
      ))}
    </div>
  );
}

function VideoEmbed({ src, label, poster }) {
  const isYouTube = /youtu\.?be/.test(src);
  const isVimeo = /vimeo\.com/.test(src);
  const isExternal = isYouTube || isVimeo;
  return (
    <figure className="relative overflow-hidden rounded-lg w-full sm:max-w-[731px] mx-auto">
      {isExternal ? (
        <div className="aspect-w-16 aspect-h-9">
          <iframe
            src={src}
            title="testimonial video"
            allow="autoplay; encrypted-media"
            allowFullScreen
            className="w-full h-full border-0"
          />
        </div>
      ) : (
        <video
          src={src}
          controls
          className="w-full h-auto object-cover"
          poster={poster ? poster : undefined}
        />
      )}
      {label && (
        <figcaption className="absolute bottom-0 left-0 right-0 bg-teal-600/90 text-white text-sm sm:text-base px-4 py-2">
          {label}
        </figcaption>
      )}
    </figure>
  );
}

function ReviewCard({ quote, author, stars = 5 }) {
  return (
    <article className="bg-white rounded-xl shadow-sm p-6 sm:p-8 flex flex-col gap-4 sm:gap-6">
      <p className="text-base sm:text-[17px] text-left font-roboto">“{quote}”</p>
      <div className="mt-auto">
        <h4 className="text-base sm:text-[18px] text-left font-roboto font-medium">{author}</h4>
        <StarRating count={stars} />
      </div>
    </article>
  );
}

export default function JoinThousands() {
  return (
    <section className="px-4 sm:px-[10%] py-12 sm:py-24 bg-white">
      <div className="max-w-6xl mx-auto text-left space-y-6">
        <h2 className="text-2xl sm:text-[30px] font-century mb-4">
          Join the Thousands Who Found Freedom
        </h2>
        <blockquote className="bg-[#9AEEDA33] rounded-lg p-4 sm:p-6 mb-4">
          <p className="text-base sm:text-[17px] font-roboto">
            <span className="text-lg sm:text-[22px] font-roboto font-bold">
              "I used to think I just had a food problem - 
            </span>{" "}
            but your retreat showed me it was really about how disconnected I was from myself. Now, I eat when I’m hungry, stop when I’m full, and no longer use food to numb or punish. I finally feel free, whole, and so much joy in my life."
          </p>
          <footer className="mt-3 text-base sm:text-[17px] font-roboto font-semibold">
            - Emily G., New York
          </footer>
        </blockquote>
        <div className="grid gap-6 sm:gap-8 md:grid-cols-2">
          <VideoEmbed
            src="https://aa0221779a48f78a9ad4-e74d0921b9d54a102fe371691c69d367.ssl.cf2.rackcdn.com/video/2022%20Clips/Videos%20for%20Retreat%20Page/Lisa-More-Unfoldings-New.mp4"
            poster={video1_poster}
          />
          <VideoEmbed
            src="https://aa0221779a48f78a9ad4-e74d0921b9d54a102fe371691c69d367.ssl.cf2.rackcdn.com/video/2022%20Clips/Videos%20for%20Retreat%20Page/Kay-Testimonial-Starting-with-one-workshop.mp4"
            poster={video2_poster}
          />
        </div>
        <div className="grid gap-6 sm:gap-8 md:grid-cols-2 lg:grid-cols-3">
          <ReviewCard
            quote="Attending Geneen’s retreat was life-changing. I’ve gained control over my emotional eating and found peace for the first time in my life."
            author="Silvana, 2021 Retreat"
          />
          <ReviewCard
            quote="Every retreat with Geneen has been a small miracle. This journey has transformed my relationship with my body and brought peace into my everyday life."
            author="Nina, 2019 Retreat"
          />
          <ReviewCard
            quote="Doing the retreat in my own home was life-changing, being right in the environment where I have the most trouble with food."
            author="Rose, 2023 Retreat"
          />
        </div>
      </div>
    </section>
  );
}